//
// App.tsx
// marcio.garcia@newsoftware.com.br
//

import { RouterProvider } from "react-router-dom";
import { NewSoftwareShell } from "@newsoftware-platform/newsoftware-lib-ui";
import { Node } from '@newsoftware-platform/newsoftware-lib-node'; 
import { createAppRouter } from "./routes.tsx"; 

import nodeViewRaw from "./assets/nsn-view-application-studio.json";

export default function App() {
  const nodeView = (nodeViewRaw as unknown) as Node;
  const loadConfig = "header|slogan|footer|sidebar|identity";

// header
// footer
// sidebar
// navbar
// slogan
// identity
  const requiredConfig = "TRUE";
  const router = createAppRouter(loadConfig, requiredConfig);
  const name = "newstack";
  const lang = "en" as any; 
  const theme = "light" as any;

  return (
    <NewSoftwareShell 
      name={name} 
      viewData={nodeView} 
      lang={lang} 
      theme={theme}
    >
      <RouterProvider router={router} />
    </NewSoftwareShell>
  );
}

